import { createSSRApp } from 'vue';
import App from '../App.vue';
import { captureAttribution } from '../analytics/attribution.js';
import { initMetrika } from '../analytics/metrika.js';
import { loadPublicData } from './public-data.js';
import { createSiteRouter } from './router.js';
import '../style.css';

/**
 * Точка входа публичного сайта: витрина и правовые документы.
 *
 * Ни Pinia, ни клиента API, ни гардов — по той же причине, что и во
 * встраиваемой панели (см. комментарий к точкам входа в `vite.config.ts`).
 * Человек, пришедший из поиска, не должен тянуть бандл кабинета и получать 401
 * на `/api/auth/me` ещё до того, как прочитал первый заголовок.
 *
 * `createSSRApp`, а не `createApp`: разметку кладёт пререндер, и приложение
 * здесь не строит страницу заново, а подхватывает готовую. `createApp` стёр бы
 * её и собрал с нуля — то есть отдал бы пустой экран на время загрузки бандла
 * и потерял бы смысл пререндера для всех, кроме краулеров.
 */
/*
 * Метки кампании снимаются ПЕРВЫМ делом, до всего остального.
 *
 * Витрина — обычная точка входа рекламы, и адресная строка несёт метки ровно
 * на этом заходе. Отложить их сбор до монтирования значит потерять их у тех,
 * кто закрыл вкладку, не дождавшись бандла.
 */
captureAttribution();

// Вебвизор только здесь: на витрине он показывает, где человек застревает, а
// в кабинете записывал бы содержимое чужих документов.
initMetrika({ webvisor: true });

const app = createSSRApp(App);
const router = createSiteRouter();

app.use(router);

void router.isReady().then(() => {
  app.mount('#app');
  // Цены и реквизиты чаще всего уже в разметке — тогда запроса не будет.
  // Он уходит, только если сборка шла без доступа к API.
  void loadPublicData();
});
